import {
  container2,
  question,
  inputWrapper,
  input,
  questionMain,
  textareaClass,
  errorClass,
} from "../../../constants/classnames";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { getAnswersByQuestion } from "../../../api/secureApi";
import { ButtonBackNext } from "../../../components/buttonBackNext";
import { CHILDREN } from "./overview";
import { handleError } from "../../../utils/handleError";
import { handleSave } from "./handleSave";
import { RadioPS } from "./radioPS";
import { LOGIN } from "./lifeCircumstances";
import { Header } from "./header";

const HOW_MANY = "how_many";
const AGES = "ages";

export function Children() {
  const navigate = useNavigate();
  const [genericErrorMessage, setGenericErrorMessage] = useState("");
  const { getValues, register, setValue, watch } = useForm({
    mode: "all",
    defaultValues: {
      [CHILDREN]: "",
    },
  });
  const current = watch(CHILDREN);

  useEffect(() => {
    window.scrollTo(0, 0);

    getAnswersByQuestion(CHILDREN)
      .then((response) => {
        response.forEach((row) => {
          setValue(CHILDREN, row.selection);
          if (row.additional_json) {
            if (row.additional_json[HOW_MANY]) {
              setValue(HOW_MANY, row.additional_json[HOW_MANY]);
            }
            if (row.additional_json[AGES]) {
              setValue(AGES, row.additional_json[AGES]);
            }
          }
        });
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.log("error getting answers", error);
        handleError(error, setGenericErrorMessage, navigate);
      });
  }, [setValue, navigate]);

  const handlePreSave = (path) => {
    const values = getValues();
    if (values[CHILDREN]) {
      if (values[CHILDREN] === "yes" && values[HOW_MANY] && values[AGES]) {
        // eslint-disable-next-line no-console
        console.log("values", values);
        setGenericErrorMessage("");
        const newDetails = [
          {
            selection: values[CHILDREN],
            additional_json: {
              [HOW_MANY]: values[HOW_MANY],
              [AGES]: values[AGES],
            },
          },
        ];
        handleSave(CHILDREN, newDetails, navigate, path);
      } else if (values[CHILDREN] === "no") {
        setGenericErrorMessage("");
        const newDetails = [
          {
            selection: values[CHILDREN],
          },
        ];
        handleSave(CHILDREN, newDetails, navigate, path);
      } else if (values[CHILDREN] === "yes" && (!values[HOW_MANY] || !values[AGES])) {
        setGenericErrorMessage("Please fill in details.");
      }
    } else {
      navigate(path);
    }
  };

  const handleBackClick = () => {
    const path = "/statement/volunteer-work";
    handlePreSave(path);
  };

  const handleNextClick = () => {
    const path = "/statement/grandchildren";
    handlePreSave(path);
  };

  const handleOverviewClick = () => {
    const path = "/statement-overview";
    handlePreSave(path);
  };

  const handleLogoutClick = () => {
    const path = LOGIN;
    handlePreSave(path);
  };

  return (
    <>
      <Header handleOverviewClick={handleOverviewClick} handleLogoutClick={handleLogoutClick} />
      <section id="heading">
        <div className={container2}>
          <div className={questionMain}>Do you have children?</div>
          <div className="pb-4">
            <RadioPS
              name={CHILDREN}
              answer="yes"
              label="yes"
              register={register}
              {...register(CHILDREN)}
              current={current}
            />
            <RadioPS
              name={CHILDREN}
              answer="no"
              label="no"
              register={register}
              {...register(CHILDREN)}
              current={current}
            />
          </div>
          {current === "yes" && (
            <div>
              <h2 className={question}>How many children do you have?</h2>
              <div className={inputWrapper}>
                <input
                  placeholder="2"
                  type="text"
                  name={HOW_MANY}
                  id={HOW_MANY}
                  className={input}
                  {...register(HOW_MANY)}
                />
              </div>
              <h2 className={question}>What are the age(s) of your child(ren)?</h2>
              <div className={inputWrapper}>
                <textarea
                  placeholder="18 months, 3 years"
                  type="text"
                  name={AGES}
                  id={AGES}
                  className={textareaClass}
                  rows="2"
                  {...register(AGES)}
                ></textarea>
              </div>
            </div>
          )}
          {genericErrorMessage && (
            <div className={errorClass} id="error">
              {genericErrorMessage}
            </div>
          )}
          <ButtonBackNext handleBackClick={handleBackClick} handleNextClick={handleNextClick} />
        </div>
      </section>
    </>
  );
}
